(function () {
  'use strict';

  function initializeGallery(gallery) {
    if (!gallery || gallery.getAttribute('data-thf-ready') === 'true') return;

    var mainImage = gallery.querySelector('[data-thf-main]') || gallery.querySelector('.thf-gallery-main img');
    var modal = gallery.querySelector('[data-thf-lightbox]');
    var modalImage = gallery.querySelector('[data-thf-modal-image]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thf-thumb]'));
    var activeIndex = 0;
    var lastFocus = null;

    if (!mainImage || !modal || !modalImage) return;
    gallery.setAttribute('data-thf-ready', 'true');

    function selectImage(nextIndex) {
      var thumb;
      var source;
      var alt;

      if (!thumbs.length) return;
      activeIndex = (nextIndex + thumbs.length) % thumbs.length;
      thumb = thumbs[activeIndex];
      source = thumb.getAttribute('data-src');
      alt = thumb.getAttribute('data-alt') || '';

      mainImage.removeAttribute('srcset');
      mainImage.setAttribute('src', source);
      mainImage.setAttribute('alt', alt);
      modalImage.setAttribute('src', source);
      modalImage.setAttribute('alt', alt);

      thumbs.forEach(function (item, index) {
        var selected = index === activeIndex;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      if (thumb.scrollIntoView) {
        thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    function previousImage(event) {
      if (event) event.preventDefault();
      selectImage(activeIndex - 1);
    }

    function nextImage(event) {
      if (event) event.preventDefault();
      selectImage(activeIndex + 1);
    }

    function openModal(event) {
      if (event) event.preventDefault();
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('thf-lightbox-open');
      var closeButton = gallery.querySelector('[data-thf-close]');
      if (closeButton) closeButton.focus();
    }

    function closeModal(event) {
      if (event) event.preventDefault();
      modal.hidden = true;
      document.documentElement.classList.remove('thf-lightbox-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function (event) {
        event.preventDefault();
        selectImage(index);
      });
    });

    var previousButton = gallery.querySelector('[data-thf-prev]');
    var nextButton = gallery.querySelector('[data-thf-next]');
    var modalPrevious = gallery.querySelector('[data-thf-modal-prev]');
    var modalNext = gallery.querySelector('[data-thf-modal-next]');
    var openButton = gallery.querySelector('[data-thf-open]');
    var closeButton = gallery.querySelector('[data-thf-close]');

    if (previousButton) previousButton.addEventListener('click', previousImage);
    if (nextButton) nextButton.addEventListener('click', nextImage);
    if (modalPrevious) modalPrevious.addEventListener('click', previousImage);
    if (modalNext) modalNext.addEventListener('click', nextImage);
    if (openButton) openButton.addEventListener('click', openModal);
    if (closeButton) closeButton.addEventListener('click', closeModal);

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal(event);
    });

    gallery.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') closeModal(event);
      if (event.key === 'ArrowLeft' && thumbs.length) previousImage(event);
      if (event.key === 'ArrowRight' && thumbs.length) nextImage(event);
    });
  }

  function initializeAll(root) {
    var scope = root || document;
    var galleries = scope.querySelectorAll ? scope.querySelectorAll('[data-thf-gallery]') : [];
    Array.prototype.forEach.call(galleries, initializeGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
